export default "__VITE_ASSET__560517bd__"